import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, tenant } from 'Shared/BaseUrl';

export default function useBank() {

    return useQuery(
        ['banks'],
        () => axios.get(baseUrl + `banks`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("ebs-client-token"),
                'X-Tenant': tenant,
            }
        })
    )
}